<template>
  <v-layout v-if="lodash.isEmpty(filteredAttendancePlaces)">
    <slot
      v-if="noTooltip"
      :actionName="actionNameWithPalce"
      :clickEvent="() => startAttendance(nextWorkflowStatus, null)"
    />

    <v-tooltip top v-else>
      <template v-slot:activator="{ on, attrs }">
        <slot
          :attrs="attrs"
          :actionName="actionNameWithPalce"
          :on="on"
          :clickEvent="() => startAttendance(nextWorkflowStatus, null)"
        />
      </template>

      <span>{{ actionNameWithPalce }}</span>
    </v-tooltip>
  </v-layout>

  <v-layout v-else-if="filteredAttendancePlaces.length === 1">
    <slot
      v-if="noTooltip"
      :actionName="actionNameWithPalce"
      :clickEvent="() => startAttendance(nextWorkflowStatus, firstAttendancePlace.id)"
    />

    <v-tooltip top v-else>
      <template v-slot:activator="{ on, attrs }">
        <slot
          :attrs="attrs"
          :actionName="actionNameWithPalce"
          :on="on"
          :clickEvent="() => startAttendance(nextWorkflowStatus, firstAttendancePlace.id)"
        />
      </template>

      <span>{{ actionNameWithPalce }}</span>
    </v-tooltip>
  </v-layout>

  <v-menu v-model="menuOpened" v-else offset-x left>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <slot
            :attrs="attrs"
            :on="{ ...tooltip, ...menu }"
            :clickEvent="() => (menuOpened = !menuOpened)"
            :moreOptions="filteredAttendancePlaces.length > 1"
            :actionName="actionName"
          />
        </template>

        <span>{{ actionName }}</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="attendancePlace in filteredAttendancePlaces"
        :key="attendancePlace.id"
        @click="startAttendance(nextWorkflowStatus, attendancePlace.id)"
      >
        <v-list-item-title>
          {{ attendancePlace.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: "ActionNextWorkflowButton",
    props: {
      attendance: Object,
      nextWorkflowStatus: Object,
      workflowStatusActionType: String,
      startAttendance: Function,
      noTooltip: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        menuOpened: false,
      };
    },
    computed: {
      actionNameWithPalce() {
        if (this.nextWorkflowStatus) {
          if (this.firstAttendancePlace?.name) {
            return `${this.nextWorkflowStatus.actionName} - ${this.firstAttendancePlace.name}`;
          }

          return `${this.nextWorkflowStatus.actionName}`;
        }

        return "";
      },
      actionName() {
        if (this.nextWorkflowStatus) {
          return this.nextWorkflowStatus.actionName;
        }

        return "";
      },
      employeePlaces() {
        return this.attendance.employeeAttendancePlaces;
      },
      attendancePlaces() {
        return this.nextWorkflowStatus.attendancePlaces;
      },
      firstAttendancePlace() {
        return this.lodash.first(this.filteredAttendancePlaces);
      },
      lastWorkflowLog() {
        return this.attendance.lastWorkflowLog;
      },
      currentAttendancePlace() {
        if (this.lastWorkflowLog) {
          return this.lastWorkflowLog.attendancePlace;
        }

        return null;
      },
      filteredAttendancePlaces() {
        if (!this.nextWorkflowStatus) {
          return [];
        }

        let currentAttendancePlaces = this.attendancePlaces;

        if (this.currentAttendancePlace) {
          // filtering by currentAttendancePlace
          currentAttendancePlaces = this.lodash.filter(
            this.attendancePlaces,
            (e) => e.id === this.currentAttendancePlace.id
          );

          let childrenPlaces = this.lodash.filter(this.attendancePlaces, (e) => {
            if (e.parent?.id) {
              return e.parent.id === this.currentAttendancePlace.id;
            }

            return false;
          });
          currentAttendancePlaces = currentAttendancePlaces.concat(childrenPlaces);

          // filtering by currentAttendancePlace parent
          if (this.lodash.isEmpty(currentAttendancePlaces)) {
            const warelineId = this.currentAttendancePlace?.parent?.id;
            currentAttendancePlaces = this.lodash.filter(
              this.attendancePlaces,
              (e) => e.id === warelineId
            );
          }

          // filtering by list parents
          if (this.lodash.isEmpty(currentAttendancePlaces)) {
            currentAttendancePlaces = this.lodash.filter(
              this.attendancePlaces,
              (e) => e?.parent?.id === this.currentAttendancePlace.id
            );
          }

          if (this.lodash.isEmpty(currentAttendancePlaces)) {
            currentAttendancePlaces = this.attendancePlaces;
          }
        }

        let filteredAttendancePlaces = [];

        const employeePlaceIds = this.lodash.flatMap(this.employeePlaces, "id");
        filteredAttendancePlaces = this.lodash.filter(currentAttendancePlaces, (e) =>
          employeePlaceIds.includes(e.id)
        );

        if (this.lodash.isEmpty(filteredAttendancePlaces)) {
          const warelineIds = this.lodash.flatMap(this.employeePlaces, "parent.id");
          filteredAttendancePlaces = this.lodash.filter(currentAttendancePlaces, (e) =>
            warelineIds.includes(e.id)
          );
        }

        // if (this.lodash.isEmpty(filteredAttendancePlaces)) {
        //   const employeePlaceIds = this.lodash.flatMap(this.employeePlaces, "id");
        //   filteredAttendancePlaces = this.lodash.filter(currentAttendancePlaces, (e) =>
        //     employeePlaceIds.includes(e?.parent?.id)
        //   );
        // }

        if (!this.lodash.isEmpty(filteredAttendancePlaces)) {
          const filteredAttendancePlaceIds = this.lodash.flatMap(
            filteredAttendancePlaces,
            (e) => (e.parent?.id ? e.parent.id : "")
          );

          let parentPlaces = this.lodash.filter(this.attendancePlaces, (e) => {
            return filteredAttendancePlaceIds.includes(e.id);
          });

          filteredAttendancePlaces = parentPlaces.concat(filteredAttendancePlaces);
        }

        if (this.lodash.isEmpty(filteredAttendancePlaces)) {
          filteredAttendancePlaces = this.attendancePlaces;
        }

        return filteredAttendancePlaces;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
